import api from 'common/api';
import {
  SearchPortMasterRequest,
  DetailPortMasterRequest,
  UpdatePortMasterRequest,
  DeletePortMasterRequest,
} from 'api-types/src/types/port-master';

export const getPortAPI = (params: SearchPortMasterRequest) => api.get('/port-master/list', params);

export const getPortDetailAPI = (params: DetailPortMasterRequest) => api.get('/port-master/detail', params);

export const addPortAPI = (params: UpdatePortMasterRequest) => api.post('/port-master', params);

export const updatePortAPI = (params: UpdatePortMasterRequest) => api.put('/port-master', params);

export const deletePortAPI = (params: DeletePortMasterRequest) => api.put('/port-master/delete', params);

export const DOWNLOAD_EXCEL_PORT_MAST = '/port-master/list';
